import * as React from 'react';
import classnames from 'classnames';
import isNil from 'lodash/isNil';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { expandDataProps } from 'utils/helper/common';
import { manageBodyScroll, resetBodyScroll } from 'utils/modal';

import type { Data } from 'types';

import type { SyntheticEvent } from 'react';
import { SVGDynamicIconCustomColor } from 'types';

type Props = {
  children: React.ReactNode,
  open: boolean,
  width?: 'small' | 'medium' | 'large' | 'auto',
  onClose?: () => void,
  onBeforeCloseModal?: () => void,
  showClose: boolean,
  positionOverride?: 'auto-centered' | 'fixed-to-top' | 'centered-no-padding',
  closeOnOverlayClick?: boolean,
  closeIconPosition: 'inner' | 'corner',
  closeIconType: 'normal' | 'fancy',
  containerClass?: string,
  data: Data
};

type IconDefitinion = {
  name: string,
  width: number,
  height: number,
  color: SVGDynamicIconCustomColor
};

const CLOSE_ICON_MAP: {
  [x: string]: IconDefitinion
} = {
  normal: {
    name: 'cross-custom-fg',
    width: 15,
    height: 15,
    color: 'grey'
  },
  fancy: {
    name: 'cross-inside-circle-custom-bg-white-fg',
    width: 40,
    height: 40,
    color: 'black'
  }
};

class ModalOpener extends React.Component<Props> {
  static defaultProps = {
    showClose: true,
    width: 'medium',
    closeIconPosition: 'inner',
    closeIconType: 'normal',
    onClose: () => {},
    onBeforeCloseModal: () => {},
    data: {}
  };

  componentDidMount() {
    manageBodyScroll();
  }

  componentDidUpdate() {
    manageBodyScroll();
  }

  componentWillUnmount() {
    resetBodyScroll();
  }

  handleCloseOnClick = () => {
    const { closeOnOverlayClick, onClose } = this.props;

    if (closeOnOverlayClick && onClose) {
      onClose();
    }
  };

  handleStopPropagation = (event: SyntheticEvent<HTMLElement>) => {
    event.stopPropagation();
  };

  render() {
    const {
      open,
      children,
      width,
      positionOverride,
      onClose,
      containerClass,
      showClose,
      closeIconPosition,
      closeIconType,
      data
    } = this.props;

    let position = width === 'small' ? 'auto-centered' : 'fixed-to-top';

    if (!isNil(positionOverride)) {
      position = positionOverride;
    }

    const classes = classnames({
      'modal-opener': true,
      'modal-opener--hidden': !open,
      [`modal-opener--position-${position}`]: position
    });

    const containerClasses = classnames({
      'modal-opener__container': true,
      [`modal-opener__container--width-${width}`]: width,
      [`${String(containerClass)}`]: Boolean(containerClass)
    });

    const closeIconClasses = classnames({
      'modal-opener__close-icon': true,
      [`modal-opener__close-icon--position-${closeIconPosition}`]: closeIconPosition,
      [`modal-opener__close-icon--type-${closeIconType}`]: closeIconType
    });

    return (
      <section className={classes} onClick={this.handleCloseOnClick}>
        {
          open && (
            <React.Fragment>
              <div
                className={containerClasses}
                {...expandDataProps(data)}
                onClick={this.handleStopPropagation}
              >
                <div className="modal-opener__frame">
                  {children}
                  {
                    showClose &&
                      <div className={closeIconClasses}>
                        <SVGDynamicIcon
                          name={CLOSE_ICON_MAP[closeIconType].name}
                          width={CLOSE_ICON_MAP[closeIconType].width}
                          height={CLOSE_ICON_MAP[closeIconType].height}
                          customColor={CLOSE_ICON_MAP[closeIconType].color}
                          onClick={onClose}
                        />
                      </div>
                  }
                </div>
                <div className="modal-opener__bottom-space" />
              </div>
              <div className="modal-opener__bottom" />
            </React.Fragment>
          )
        }
      </section>
    );
  }
}

export default ModalOpener;
